import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextField from "UI/Form/TextField";
import Button from "UI/Button";

import { Link } from 'react-router-dom';

import validate from './validation.js';
import Logo from "Components/Logo";
import Form from "Components/Form/Form";

export default class SignupForm extends React.Component
{
    state = {
        busy: false,
        failed: false
    };

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    };

    submit = data => {
        this.props.onSubmit(data).catch(error => {
            this.setState({busy: false, failed: true});
        });
    };

    render()
    {
        const defaultValues = {
            firstname: '',
            lastname: '',
            email: '',
            organisation: '',
        };

        return <div className="w-full max-w-lg">
            <Logo className="h-12 text-white mb-4 m-auto" />

            <Form defaults={defaultValues} validate={validate} onSubmit={this.submit}>
                {
                    (data, onChange, validation) => <fieldset disabled={this.state.busy} className="bg-white shadow-md rounded px-8 pt-10 pb-8 mb-4 space-y-4 prose">

                        <h1>Get started with Patchwork</h1>

                        <div className='mt-2 grid grid-cols-1 gap-x-4 sm:grid-cols-6'>

                            <div className='sm:col-span-3'>
                                <TextField
                                    id="firstname"
                                    label="First name"
                                    placeholder="e.g. Mickey"
                                    value={data.firstname || ''}
                                    onChange={onChange('firstname')}
                                    error={validation.hasErrors('firstname')}
                                    help={validation.getErrors('firstname')}
                                />
                            </div>
                            <div className='sm:col-span-3'>
                                <TextField
                                    id="lastname"
                                    label="Last name"
                                    placeholder="e.g. Mouse"
                                    value={data.lastname || ''}
                                    onChange={onChange('lastname')}
                                    error={validation.hasErrors('lastname')}
                                    help={validation.getErrors('lastname')}
                                />
                            </div>

                            <div className='sm:col-span-6'>
                                <TextField
                                    id="email"
                                    label="Email address"
                                    placeholder="e.g. mickey@acme.org"
                                    type='email'
                                    value={data.email || ''}
                                    onChange={onChange('email')}
                                    error={validation.hasErrors('email')}
                                    help={validation.getErrors('email')}
                                />
                            </div>

                            <div className='sm:col-span-6'>
                                <TextField
                                    id="organisation"
                                    label="Organisation name"
                                    placeholder="e.g. Acme Corp"
                                    value={data.organisation || ''}
                                    onChange={onChange('organisation')}
                                    error={validation.hasErrors('organisation')}
                                    help={validation.getErrors('organisation')}
                                />
                            </div>

                        </div>

                        {
                            this.state.failed &&
                                <div className="flex items-center justify-between mt-4 text-sm text-red-600">
                                    Oh no. There was a problem submitting your signup request!
                                </div>
                        }

                        <div className="flex items-center justify-between">
                            <Button type='primary' busy={this.state.busy}>Register</Button>
                        </div>

                        <p className="text-sm text-gray-500">
                            By signing up, you agree to our <a href="https://trypatchwork.com/privacy" target="_blank" rel="noopener noreferrer" className='text-indigo-500'>privacy policy</a>.
                        </p>

                    </fieldset>
                }
            </Form>

            <div className='text-center text-white'>
                Already have an account? <Link to='/login' className='underline'>Login</Link>.
            </div>

        </div>;
    }
}
